// Imports
import Vue from "vue";
import Router from "vue-router";
import { trailingSlash } from "@/util/helpers";
import { layout, route } from "@/util/routes";
import firebase from "firebase";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    route("HomePage", null, "/"),
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/register/:userId",
      name: "Register",
      props: true,
      component: () => import("@/views/users/Register"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/edituser/:userId/:toClose",
      name: "EditUser",
      props: true,
      component: () => import("@/views/users/EditUser"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/addcv/:schoolId/:collectionName/:userId",
      name: "CvUser",
      props: true,
      component: () => import("@/views/users/CvUser"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/signup",
      name: "SignUp",
      component: () => import("@/views/users/SignUp"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/newstudentregistration',
      name: 'NewStudentRegistration',
      props: true,
      component: () => import('@/views/students/NewStudentRegistration'),
      meta: {
        requiresAuth: false,
      },
    },
    layout('Default', [
      // Pages
      route("UserProfile", null, "components/profile"),
      route("MySetting", null, "components/mysetting"),
      // Components
      route("Dashboard", null, "dashboard"),
      // Tables
      route("Regular Tables", null, "tables/regular"),
      route("Asuulga", null, "asuumj"),
   
      {
        path: "tables/organizationmanagement",
        name: "OrganizationManagement",
        props: true,
        component: () => import("@/views/externorganizations/OrganizationManagement"),
        meta: {
          requiresAuth: true
        }
      },
      //admin
      {
        path: 'tables/asuulga/:asuulgaPath',
        name: 'AsuulgaEditing',
        props: true,
        component: () => import('@/views/asuulga/AsuulgaEditing'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'tables/answerasuulga/:asuulgaRefPath',
        name: 'AnswerAsuulga',
        props: true,
        component: () => import("@/views/asuulga/AnswerAsuulga"),
      },
      {
        path: "tables/statistics",
        name: "Statistics",
        props: true,
        component: () => import("@/views/admin/Statistics"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/searchscores",
        name: "SearchScores",
        props: true,
        component: () => import("@/views/admin/SearchScores"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'tables/studentsscorecomparison',
        name: 'StudentsScoreComparison',
        props: true,
        component: () => import('@/views/admin/StudentsScoreComparison'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'tables/scoreconflictanalysis',
        name: 'ScoreConflictAnalysis',
        props: true,
        component: () => import('@/views/admin/ScoreConflictAnalysis'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'tables/scoreconfirmation',
        name: 'ScoreConfirmation',
        props: true,
        component: () => import('@/views/admin/ScoreConfirmation'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'tables/diplomastudents',
        name: 'DiplomaStudents',
        props: true,
        component: () => import('@/views/admin/DiplomaStudents'),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: 'tables/diplomatemplate/:studentRefPath',
        name: 'DiplomaTemplate',
        props: true,
        component: () => import('@/views/diploma/DiplomaTemplate.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      //accoutant

      {
        path: "tables/paymentregister",
        name: "PaymentRegister",
        props: true,
        component: () => import("@/views/accountant/PaymentRegister"),
        meta: {
          requiresAuth: true
        }
      },

      //students

      {
        path: "tables/lessonstudentpreview",
        name: "LessonStudentPreview",
        props: true,
        component: () => import("@/views/students/LessonStudentPreview"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/soril",
        name: "Soril",
        component: () => import("@/views/soril/PageSorilAssignments.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/sorilresults",
        name: "StudentShowAssignmentAllResults",
        props: true,
        component: () => import("@/views/soril/XShowAssignmentAllResults.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/sorilsharing",
        name: "XShalgaltSharing",
        props: true,
        component: () => import("@/views/soril/XShalgaltSharing.vue")
      },

      {
        path: "/tables/shalgalteditingeyesh/:xpath",
        name: "XShalgaltEditingEyesh",
        props: true,
        component: () => import("@/views/soril/XShalgaltEditingEyesh.vue"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "tables/studentscores",
        name: "StudentScores",
        props: true,
        component: () => import("@/views/students/StudentScores"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/studentpayments",
        name: "StudentPayments",
        props: true,
        component: () => import("@/views/students/StudentPayments"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "/tables/todorhoiloltuudavah",
        name: "TodorhoiloltuudAvah",
        component: () => import("@/views/todorhoilolt/TodorhoiloltuudAvah.vue"),
        props: true,
        meta: {
          groupName: "Pages",
          requiresAuth: true
        }
      },

      {
        path: "tables/studentlessons",
        name: "StudentLessons",
        props: true,
        component: () => import("@/views/students/StudentLessons"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/studentexams",
        name: "StudentExams",
        props: true,
        component: () => import("@/views/students/StudentExams"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "tables/studenttakeexam/:shalgaltIdd",
        name: "StudentTakeExam",
        props: true,
        component: () => import("@/views/soril/StudentTakeExam.vue")
      },
      {
        path: "tables/studentresult/:shalgaltIdd",
        name: "StudentResult",
        props: true,
        component: () => import("@/views/soril/StudentResult.vue")
      },
      {
        path: "tables/teacherlessons",
        name: "TeacherLessons",
        props: true,
        component: () => import("@/views/lessons/TeacherLessons"),
        meta: {
          // groupName: "Pages",
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: "tables/teacherlessonsplan",
        name: "TeacherLessonsPlan",
        props: true,
        component: () => import("@/views/lessons/TeacherLessonsPlan"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "/tables/classhuvaari",
        name: "ClassHuvaari",
        component: () => import("@/views/huvaari/ClassHuvaari.vue"),
        props: true,
        meta: {
          groupName: "Pages",
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: "tables/atsagteacherlessons",
        name: "ATsagTeacherLessons",
        props: true,
        component: () => import("@/views/teacher/ATsagTeacherLessons"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/atsagteacherlessonsbyteacher/:teacherRef",
        name: "ATsagTeacherLessonsByTeacher",
        props: true,
        component: () => import("@/views/teacher/ATsagTeacherLessonsByTeacher"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'tables/atsagteacherlessonsbyteachermenu',
        name: 'ATsagTeacherLessonsByTeacherMenu',
        props: true,
        component: () => import('@/views/teacher/ATsagTeacherLessonsByTeacherMenu'),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "tables/teacherworks",
        name: "TeacherWorks",
        props: true,
        component: () => import("@/views/teacher/TeacherWorks"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/mydepartment",
        name: "MyDepartment",
        props: true,
        component: () => import("@/views/MyDepartment"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/teacherlessondetail/:xpath",
        name: "TeacherLessonDetail",
        props: true,
        component: () => import("@/views/lessons/TeacherLessonDetail"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/studentlessondetail/:xpath",
        name: "StudentLessonDetail",
        props: true,
        component: () => import("@/views/students/StudentLessonDetail"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/curriculums",
        name: "Curriculums",
        props: true,
        component: () => import("@/views/Curriculums"),
        meta: {
          requiresAdmin: true
        }
      },
      {
        path: 'tables/lessonstandards',
        name: 'LessonStandards',
        props: true,
        component: () => import('@/views/LessonStandards'),
        meta: {
          requiresAdmin: true,
        },
      },
      {
        path: 'tables/:schoolId/curriculumdetail/:curriculumId',
        name: 'CurriculumDetail',
        props: true,
        component: () => import("@/views/CurriculumDetail"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'tables/:schoolId/diplomascoretemplate/:curriculumId',
        name: 'DiplomaScoreTemplate',
        props: true,
        component: () => import('@/views/diploma/DiplomaScoreTemplate.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'tables/lessonstandarddetail/:xpath',
        name: 'LessonStandardDetail',
        props: true,
        component: () => import("@/views/lessons/LessonStandardDetail"),
        meta: {
          requiresAuth: true
        }
      },

      {
        path: "tables/studentdetail/:studentPath/:collectionpath",
        name: "StudentDetail",
        props: true,
        component: () => import("@/views/students/StudentDetail"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/adminstudentscores/:studentPath",
        name: "AdminStudentScores",
        props: true,
        component: () => import("@/views/students/AdminStudentScores"),
        meta: {
          requiresAuth: true,
          requiresAuth: true
        }
      },
      {
        path: "tables/subpaymenttable/:studentpaymentpath",
        name: "SubPaymentTable",
        props: true,
        component: () => import("@/views/students/SubPaymentTable"),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },

      //route('Employees', null, 'tables/employees'),
      //route('Students', null, 'tables/students'),

      {
        path: "tables/employees",
        name: "Employees",
        props: true,
        component: () => import('@/views/teacher/Employees'),
        meta: {
          requiresAdmin: true,
        },
      },



      {
        path: 'tables/employeesall',
        name: 'EmployeesAll',
        props: true,
        component: () => import('@/views/EmployeesAll'),
        meta: {
          requiresAdmin: true,
        },
      },
      {
        path: 'tables/students',
        name: 'Students',
        props: true,
        component: () => import('@/views/Students'),
        meta: {
          requiresAdmin: true,
        },
      },
      {
        path: 'tables/newstudents',
        name: 'NewStudentsTable',
        props: true,
        component: () => import('@/views/students/NewStudentsTable'),
        meta: {
          requiresAdmin: true,
        },
      },
      {
        path: 'tables/studentsscoresmenu',
        name: 'StudentsScoresMenu',
        props: true,
        component: () => import('@/views/students/StudentsScoresMenu'),
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "tables/employeesall",
        name: "EmployeesAll",
        props: true,
        component: () => import("@/views/EmployeesAll"),
        meta: {
          requiresAdmin: true
        }
      },
      {
        path: "tables/students",
        name: "Students",
        props: true,
        component: () => import("@/views/Students"),
        meta: {
          requiresAdmin: true
        }
      },
      {
        path: "tables/studentsscoresmenu",
        name: "StudentsScoresMenu",
        props: true,
        component: () => import("@/views/students/StudentsScoresMenu"),
        meta: {
          requiresAdmin: true
        }
      },

      {
        path: "tables/studentspergroup/:lesson/:lessonexams",
        name: "StudentsPerGroup",
        props: true,
        component: () => import("@/views/StudentsPerGroup"),
        meta: {
          requiresAdmin: true
        }
      },

      route("SettingTables", null, "tables/settingtables"),
      {
        path: "tables/settings/schoolyearcalendar/:item",
        name: "SchoolYearCalendar",
        props: true,
        component: () => import("@/views/settings/SchoolYearCalendar"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/todorhoilolt/:itemRefPath",
        name: "TodorhoiloltDetail",
        props: true,
        component: () => import("@/views/todorhoilolt/TodorhoiloltDetail"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tables/todorhoilolt/:itemRefPath",
        name: "TodorhoiloltDetail2",
        props: true,
        component: () => import("@/views/todorhoilolt/TodorhoiloltDetail2"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/tables/todorhoiloltuud",
        name: "Todorhoiloltuud",
        component: () => import("@/views/todorhoilolt/Todorhoiloltuud.vue"),
        props: true,
        meta: {
          groupName: "Pages",
          requiresAuth: true
        }
      },

      // Maps
      {
        path: "/coursedetail/:courseId",
        name: "CourseDetail",
        props: true,
        component: () => import("@/views/courses/CourseDetail"),
        // children: [
        //     {
        //         path: 'qresponses',
        //         name: 'Qresponses',
        //         props: true,
        //         component: () => import('../views/MySetting'),
        //     },
        //     {
        //       path: 'qquestionediting',
        //       name: 'QEditing',
        //       props: true,
        //       component: () => import('../views/question/QuestionEditing'),
        //     },
        //     {
        //       path: 'zparticipants',
        //       name: 'ZParticipants',
        //       props: true,
        //       component: () => import('@/views/question/ZParticipants'),
        //     },
        //     {
        //       path: 'zresponses',
        //       name: 'ZResponses',
        //       props: true,
        //       component: () => import('@/views/question/ZResponses'),
        //     },
        // ],
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/qdetail/:asuulgaId",
        name: "QDetail",
        props: true,
        component: () => import("@/views/QDetail"),
        children: [
          {
            path: "qresponses",
            name: "Qresponses",
            props: true,
            component: () => import("../views/QuestionnaireAnalyse"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: "qquestionediting",
            name: "QEditing",
            props: true,
            component: () => import("../views/question/QuestionEditing"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: "zparticipants",
            name: "ZParticipants",
            props: true,
            component: () => import("@/views/question/ZParticipants"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: "zresponses",
            name: "ZResponses",
            props: true,
            component: () => import("@/views/question/ZResponses"),
            meta: {
              requiresAuth: true
            }
          }
        ],
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "https://asuulga-mat.web.app/viewquestions/:asuulgaId",
        name: "ViewQuestions",
        props: true,
        component: () => import("@/views/question/ViewQuestions"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/viewcertification",
        name: "ViewCertification",
        component: () => import("@/views/question/ViewCertification"),
        meta: {
          requiresAuth: false
        }
      }
    ])
  ]
});

// router.beforeEach((to, from, next) => {
//   return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
// })
import store from "@/store/index.js";
router.beforeEach((to, from, next) => {
  console.log(store);
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin);
  const currentUser = firebase.auth().currentUser;
  console.log(requiresAdmin, requiresAuth, currentUser);
  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (requiresAuth && currentUser) {
    if (requiresAdmin) {
      if (
        store.state.userProfile.role == "teacher" ||
        store.state.userProfile.role == "admin" ||
        store.state.userProfile.role == "accountant"
      ) {
        next();
      } else {
        next("/");
      }
    } else {
      next();
    }
  } else if (requiresAuth === false) {
    if (requiresAdmin) {
      if (
        store.state.userProfile.role == "teacher" ||
        store.state.userProfile.role == "admin" ||
        store.state.userProfile.role == "accountant"
      ) {
        next();
      } else {
        next("/");
      }
    } else {
      next();
    }
  } else {
    next("/login");
  }
});
export default router;
